// extracted by mini-css-extract-plugin
export default {"userInfo":"styles_userInfo__GVrlq","userDescription":"styles_userDescription__DJaWT","highlight":"styles_highlight__27WE4","phone":"styles_phone__0aVFX"};